module.exports = __webpack_public_path__ + "img/user.d30e15a2.png";